import React from 'react'
import { Form, Button, Spinner } from 'reactstrap'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'hooks'
import { TextField, DateField, SelectField } from 'components/form'
import { useSuppliers, useReferentiel } from 'api'

interface Props extends FormikProps<Partial<Contract>> {
  isLoading: boolean
}

export const ContractForm: React.FC<Props> = ({ isLoading, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme() as any
  const supplierOptions = useSuppliers()

  const { ListePays, ListeEnergie, ListeTypeContrat, ListeDelaiPaiement, ListeDevise, ListCHRPas } =
    useReferentiel()

  const ListValoPas = ListCHRPas.filter(c => c.value == 5 || c.value == 7)

  const keys = Object.keys(props.values)

  const isDisabled = isLoading || props.isSubmitting || Object.keys(props.touched).length === 0
  const hasError = Object.keys(props.errors).length > 0

  return (
    <Form
      onSubmit={props.handleSubmit}
      css={{
        section: {
          display: 'grid',
          gridGap: theme.spacing,
          gridTemplateColumns: 'repeat(2, 1fr)',
          paddingTop: theme.spacing,
          paddingBottom: theme.spacing * 2,
        },
        footer: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '>*': {
            display: 'flex',
            justifyContent: 'flex-end',
            button: { marginLeft: '0.6rem' },
          },
        },
      }}
    >
      <section>
        {keys.includes('NomLong') && (
          <TextField name="NomLong" label={t('contract.infos.labels.nomLong')} disabled />
        )}
        {keys.includes('NomCourt') && (
          <TextField name="NomCourt" label={t('contract.infos.labels.nomCourt')} disabled />
        )}
        <TextField name="Nom" label={t('contract.infos.labels.nom')} />
        <TextField name="Complement" label={t('contract.infos.labels.complement')} />
        <SelectField
          name="Type"
          label={t('contract.infos.labels.type')}
          options={ListeTypeContrat}
        />
        <SelectField name="Nrj" label={t('contract.infos.labels.nrj')} options={ListeEnergie} />
        <DateField name="DebutLivraison" label={t('contract.infos.labels.debut')} />
        <DateField name="FinLivraison" label={t('contract.infos.labels.fin')} />
        <SelectField name="PaysId" label={t('contract.infos.labels.pays')} options={ListePays} />
        <SelectField
          name="Devise"
          label={t('contract.infos.labels.devise')}
          options={ListeDevise}
        />
        <SelectField
          name="FournisseurId"
          label={t('contract.infos.labels.fournisseur')}
          options={supplierOptions}
        />
        <DateField name="DateSignature" label={t('contract.infos.labels.dateSignature')} />
        <SelectField
          name="DelaiReglement"
          label={t('contract.infos.labels.delaiPaiement')}
          options={[{ value: 0, label: '' }, ...ListeDelaiPaiement]}
        />
        <SelectField
          name="ValorisationPas"
          label={t('contract.infos.labels.valopas')}
          options={[{ value: 0, label: '' }, ...ListValoPas]}
        />
      </section>

      <footer>
        <div />
        <div>
          <Button color="light" onClick={() => props.resetForm()} disabled={isDisabled}>
            {t('global.reset')}
          </Button>

          <Button type="submit" disabled={isDisabled || hasError}>
            {isLoading && <Spinner size="sm" style={{ marginRight: '.6rem' }} />}
            <span>{t('global.validate')}</span>
          </Button>
        </div>
      </footer>
    </Form>
  )
}
